'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var simple = exports.simple = {
  base: {
    borderRadius: '5px',
    background: '#fff',
    boxShadow: '0px 0px 14px rgba(0,0,0,0.3)',
    color: '#2c2c2c'
  },
  content: {
    fontSize: '14px',
    lineHeight: '16px',
    padding: '8px 10px'
  },
  border: {
    borderColor: 'white',
    marginBottom: '-2px'
  }
};